import { Box, TextField, Typography, TextFieldProps } from '@mui/material'
import React, { useEffect, useState } from 'react'

const useRemainLength = (maxLength: number): [number, (currentLength: number) => void] => {
  const [remainingLength, setRemainingLength] = useState(maxLength)
  const updateRemainingLength = (currentLength: number) => {
    setRemainingLength(maxLength - currentLength)
  }
  return [remainingLength, updateRemainingLength]
}

export type TextFieldWithRemainingLengthProps = TextFieldProps & {
  maxLength: number
  withText?: boolean
  small?: boolean
}

export const TextFieldWithRemainingLength = ({
  maxLength,
  withText = true,
  small = false,
  onChange,
  ref,
  ...props
}: TextFieldWithRemainingLengthProps) => {
  const [remainingLength, updateRemainingLength] = useRemainLength(maxLength)
  const handleChange: TextFieldWithRemainingLengthProps['onChange'] = (e) => {
    onChange?.(e)
    updateRemainingLength(e.target.value.length)
  }

  useEffect(() => {
    const value = props.value
    if (typeof value === 'string') {
      updateRemainingLength(value.length)
    }
  }, [props.value, updateRemainingLength])

  return (
    <>
      <TextField {...props} onChange={handleChange} ref={ref}></TextField>
      <Box
        sx={{
          fontSize: !small ? '21px' : '16px',
          float: 'right',
          marginLeft: 'auto',
          color: (theme) => (remainingLength >= 0 ? theme.palette.grey[700] : theme.palette.error.main),
        }}
      >
        {withText ? <Typography variant="caption">あと</Typography> : null}
        {remainingLength}
        {withText ? <Typography variant="caption">文字入力できます</Typography> : null}
      </Box>
    </>
  )
}
